import { ApiClient } from '@stereograph/teia-system-design/utils';
import { JwtPayload } from 'jwt-decode';

export interface IdentityUser {
  id: string;
  email: string;
  userName: string;
}

/**
 * @param instance_token
 */
export interface DecodedJwtPayload extends JwtPayload {
  instance_token: string;
}

export const IdentityApi = (client: ApiClient) => ({
  instanceToken: client.instanceToken,

  getAllUserByInstance(instanceToken: string) {
    const url = client.URL(`${instanceToken}/users`);
    const request = new Request(url, {
      method: 'GET',
    });

    return client.sendRequest<Array<IdentityUser>>(request);
  },
});
